import { createFileRoute } from "@tanstack/react-router";
import { usePreloadedQuery } from "react-relay";
import { HomePage } from "~/components/HomePage";
import { Route as HubMetaNameRoute, hubMetaNameQuery } from "./route";
import type { routeHubMetaNameQuery } from "./__generated__/routeHubMetaNameQuery.graphql";

export const Route = createFileRoute("/$hubMetaName/")({
	component: RouteComponent,
});

function RouteComponent() {
	const { hubMeta } = usePreloadedQuery<routeHubMetaNameQuery>(hubMetaNameQuery, HubMetaNameRoute.useLoaderData());

	return (
		<HomePage
			scannedHub={{
				id: hubMeta.hub.id,
				name: hubMeta.name,
			}}
		/>
	);
}
